import { Injectable } from '@angular/core';
import {
  KetQuaTraCuu,
  ThuaDatEntity,
  ThongTinQuyHoachService,
  ToaDo,
  QueryThuaDat,
} from 'lib';
import { BehaviorSubject } from 'rxjs';

export interface KetQuaTraCuuSource {
  data?: KetQuaTraCuu;
  message?: string;
  loading?: boolean;
  display?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private ketQuaTraCuuSource = new BehaviorSubject<KetQuaTraCuuSource>({});
  ketQuaTraCuu$ = this.ketQuaTraCuuSource.asObservable();

  get view() {
    return this.thongTinQuyHoachService.view;
  }
  drawGraphicByCoords = this.thongTinQuyHoachService.drawGraphicByCoords.bind(
    this.thongTinQuyHoachService
  );

  constructor(private thongTinQuyHoachService: ThongTinQuyHoachService) {
    this.thongTinQuyHoachService.data$.subscribe((data) => {
      this.ketQuaTraCuuSource.next({
        ...this.ketQuaTraCuuSource.value,
        data,
      });
    });
  }

  setKetQuaTraCuu(params: KetQuaTraCuuSource, replace = false) {
    if (replace) {
      this.ketQuaTraCuuSource.next(params);
    } else {
      this.ketQuaTraCuuSource.next({
        ...this.ketQuaTraCuuSource.value,
        ...params,
      });
    }
  }

  async layThongTinQuyHoach(params: {
    point?: __esri.Point;
    thuaDat?: QueryThuaDat;
    toaDos?: ToaDo[];
  }) {
    this.setKetQuaTraCuu(
      {
        display: true,
        message: 'Đang tải thông tin quy hoạch, vui lòng chờ...',
        loading: true,
      },
      true
    );
    const { point, thuaDat, toaDos } = params;
    try {
      let paths:number[][];
      if (toaDos) {
        if (toaDos.length < 3) {
          throw new Error(`Vui lòng nhập ít nhất 4 cặp tọa độ`);
        }
        paths=[];
        toaDos.forEach((toaDo) => {
          if (toaDo.toaDoX && toaDo.toaDoY) {
            paths.push([toaDo.toaDoY, toaDo.toaDoX]);
          }
        });
      }
      const input = {
      point,
        thuaDat,
        paths
      };
       await this.thongTinQuyHoachService.layThongTinQuyHoach(input);
      this.setKetQuaTraCuu({ message: '' });
    } catch (error) {
      this.setKetQuaTraCuu({
        message: (error && error.message) || 'Có lỗi xảy ra vui lòng thử lại',
      });
    } finally {
      this.setKetQuaTraCuu({ loading: false });
    }
  }

  close() {
    this.thongTinQuyHoachService.close();
    this.setKetQuaTraCuu({}, true);
  }
}
